<template>
  <div>
    <div class="accordion" role="tablist" v-if="project && project.salesReport">
      <div>
        <h1>{{ $t('roofLayout') }}</h1>
        <RoofLayout :cards="cards" :project="project" />
      </div>
      <div>
        <h1>{{ $t('hak') }}</h1>
        <Hak :cards="cards" :project="project" />
      </div>
      <div>
        <h1>{{ $t('zs') }}</h1>
        <Zs :cards="cards" :project="project" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import RoofLayout from './MobileSales/RoofLayout.vue';
import Hak from './MobileSales/Hak.vue';
import Zs from './MobileSales/Zs.vue';

export default {
  name: 'MobileProjectsSalesReport',
  components: {
    RoofLayout,
    Hak,
    Zs,
  },
  props: {
    project: { type: Object },
  },
  data() {
    return {
      cards: {
        /** Roof Layout Section */
        salesRoofSidesAttachments: {
          name: 'salesRoofSidesAttachments',
          navigateTo: this.goToCard,
          successor: 'salesHakLocationState',
          predecessor: null,
          opened: true,
          completed: this.completedState,
        },

        /** HAK Section */
        salesHakLocationState: {
          name: 'salesHakLocationState',
          navigateTo: this.goToCard,
          successor: 'salesHakAttachments',
          predecessor: 'salesRoofSidesAttachments',
          opened: false,
          completed: this.completedState,
        },
        salesHakAttachments: {
          name: 'salesHakAttachments',
          navigateTo: this.goToCard,
          successor: 'salesZsLocationState',
          predecessor: 'salesHakLocationState',
          opened: false,
          completed: this.completedState,
        },

        /** ZS Section */
        salesZsLocationState: {
          name: 'salesZsLocationState',
          navigateTo: this.goToCard,
          successor: 'salesZsWithCoverAttachments',
          predecessor: 'salesHakAttachments',
          opened: false,
          completed: this.completedState,
        },
        salesZsWithCoverAttachments: {
          name: 'salesZsWithCoverAttachments',
          navigateTo: this.goToCard,
          successor: null,
          predecessor: 'salesZsLocationState',
          opened: false,
          completed: this.completedState,
        },
      },
      selectedProjectAttachmentType: null,
    };
  },

  computed: {
    ...mapGetters(['getReportTemplateImages']),
    isFlatRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'FLAT_ROOF';
    },
    isPitchedRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'PITCHED_ROOF';
    },
  },

  methods: {
    ...mapActions([
      'uploadProjectAttachment',
      'saveReportSignature',
      'updateProject',
      'fetchEnumValues',
    ]),

    /**
     * save the project and open the target card
     */
    async goToCard(target, update = true) {
      let card = target;
      this.toggle(this.cards[card]);

      if (update) {
        await this.updateProject(this.project);
      }
    },

    toggle(item) {
      item.opened = !item.opened;
    },

    /**
     * Emit a scroll event, the AccordionCard Component will resolve it
     */
    scrollTo(name) {
      this.$eventHub.$emit('scroll-to-accordion', name);
    },

    /**
     * Map a completed state to each field
     */
    completedState(type, newValue = null) {
      this.project.salesReport.completed = this.project.salesReport.completed
        ? this.project.salesReport.completed
        : [];

      const existingField = this.project.salesReport.completed.find((field) => field.type === type);

      if (!existingField) {
        const newField = { type: type, value: false };

        this.project.salesReport.completed.push(newField);
        return newField.value;
      } else if (newValue !== null) {
        existingField.value = newValue;
      }

      return existingField.value;
    },

    async onUploadProjectAttachment(payload) {
      await this.uploadProjectAttachment(payload);
    },
  },
  async mounted() {
    await this.fetchEnumValues('HouseLocationState');
    // Initialize salesReport if it doesn't exist
    if (!this.project.salesReport) {
      this.project.salesReport = {
        completed: [],
      };
    }
  },
};
</script>

<style lang="scss" scoped>
/** accordion */
.accordion button {
  text-align: left;
  padding: 0.8em 0.5em;
}
.accordion .card,
.accordion .card-header {
  border: 0;
  border-radius: 0em;
}
.accordion .btn.btn-block {
  border: 0;
  border-radius: 0em;
  font-weight: bold;
}
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
